import { useFormContext, type FieldValues } from 'react-hook-form'
import { Checkbox } from '../ui/checkbox'
import { FormControl, FormField, FormItem, FormLabel } from '../ui/form'

export interface CheckboxFieldProps {
	name:            string
	label?:          string
	disabled?:       boolean
	className?:      string
	labelClassName?: string
}

export function CheckboxField({ name, label, disabled, className, labelClassName }: CheckboxFieldProps) {
	const form = useFormContext<FieldValues>()
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem className={className ?? 'relative flex flex-row items-center gap-2 space-y-0'}>
					<FormControl>
						<Checkbox
							name={name}
							checked={(field.value as boolean | undefined) ?? false}
							onCheckedChange={(c) => field.onChange(c === true)}
							disabled={disabled}
						/>
					</FormControl>
					{label && (
						<FormLabel className={labelClassName ?? 'font-[400] cursor-pointer'}>
							{label}
						</FormLabel>
					)}
				</FormItem>
			)}
		/>
	)
}
